// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__37EiJ","dragIcon":"SortableItem_dragIcon__1aO71","disabled":"SortableItem_disabled__3EV2d"};